module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ooo-wrapper"
  }, [_c('div', {
    staticClass: "ooo-container",
    class: {
      empty: _vm.staff.length === 0
    }
  }, [(_vm.staff.length === 0) ? _c('div', {
    staticClass: "nobody-out"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Nobody is out today!")])]) : _c('h2', [_vm._v("Out Today")]), _vm._v(" "), _c('ul', {
    staticClass: "staff-wrapper"
  }, _vm._l((_vm.staff), function(s) {
    return _c('li', {
      key: s.employeeId,
      staticClass: "staff"
    }, [_c('img', {
      attrs: {
        "src": '/staff/image?id=' + s.employeeId
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(s.firstName))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4b122b0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/mini-ooo.vue
// module id = 570
// module chunks = 0